import type { CharlieRecords } from "../types";

interface RecordsModalProps {
  records: CharlieRecords;
  onClose: () => void;
}

/**
 * "Open Orders" / "Open Patients" — the drill behind a suggestion. Charlie only
 * ever asserts what the underlying records say, so every item can be opened to
 * the rows that produced it.
 *
 * The table is column-agnostic on purpose: `[Charlie].[GetSignalDrillDown]`
 * returns a different column set per `SignalDrillDownType`, so the headers come
 * with the data. A drill with no headers is a mock fixture's label/value pairs,
 * and keeps the two-column reading it was written for.
 */
export function RecordsModal({ records, onClose }: RecordsModalProps) {
  const pairs = !records.columns?.length;
  return (
    <div className="ch-overlay" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="modal">
        <button className="mclose" onClick={onClose}>✕</button>
        <h3>{records.title}</h3>
        <div className="msub">{records.subtitle}</div>
        {records.rows.length === 0 ? (
          <div className="empty">No records behind this one.</div>
        ) : (
          <table>
            {!pairs && (
              <thead>
                <tr>
                  {records.columns?.map((c, i) => (
                    <th key={i}>{c}</th>
                  ))}
                </tr>
              </thead>
            )}
            <tbody>
              {records.rows.map((r, i) => (
                <tr key={i}>
                  {r.map((c, j) => (
                    // The pair fixtures read as label → value, so the value
                    // column stays right-aligned; a real drill is a plain grid.
                    <td key={j} className={j === 0 ? undefined : pairs ? "num sub2" : "sub2"}>
                      {c}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
